import { getCpeId } from "store/api/mixin/TraxisCpeIdMixin"
import { rootStore } from "store/RootStore"
import { appVersion } from "utils/TestSupport"
import { parsedUa, browserName, browserVersion, browserOs, isMobileScreenSize, isPhoneSize, isIpad, isAndroid, isDesktop } from "utils/Utils"

let alerted = false
export const getQlHeaders = (() => {
   const headers = {}
   const cpeid = getCpeId()

   // MTVW-921
   //headers['X-Quickline-Deviceid'] = cpeid ? cpeid : 'undefined'
   headers['X-Quickline-Deviceid'] = cpeid ?? ""
   // MTVW-921
   //headers['X-Quickline-Userid'] = rootStore?.sso?.contractId ? rootStore?.sso?.contractId : rootStore.sso.browserStore.getContractId()
   headers['X-Quickline-Userid'] = rootStore?.sso?.contractId
   //let profileId = rootStore?.sso?.profile?.id ?? ""
   let profileId = rootStore?.sso?.profile?.id ? rootStore.sso.profile.id : rootStore.sso.browserStore.currentProfileId ?? ""
   // MTVW-609: avoid backend errors with missing header properties
   // profileId might be temporarily null after profile deletion, use main profile in this case
   /* MTVW-921: should be ok to return an empty profileId
   if (!profileId && rootStore.sso.profileOrder?.length > 0) {
      const mainProfile = rootStore.sso.profileOrder.filter(i => {
         return (i?.isMainProfile === true)
      })
      if (mainProfile.length === 1) {
         profileId = mainProfile[0].id
         //console.debug("mainProfile", mainProfile)
      }
   }
   */
   // MTVW-921
   headers['X-Quickline-Profileid'] = profileId ?? ""

   // MTVW-1153
	const parsed = parsedUa()
   const deviceParts = [
      parsed?.device?.vendor,
      parsed?.device?.type,
      isIpad() && !isMobileScreenSize() ? "iPad" : parsed?.device?.model,
   ].filter(Boolean).join(" ")

   let xAppHeader = `Quickline TV Web/${appVersion()} (${deviceParts ?? ""}${deviceParts.length > 0 ? "; " : ""}${parsed?.os?.name ?? ""} ${parsed?.os?.version ?? ""} ${parsed?.cpu?.architecture ?? ""}; ${parsed?.browser?.name ?? ""} ${parsed?.browser?.version ?? ""})`
   xAppHeader = xAppHeader.replace(" ;", ';')
	// MTVW-1153: disable for now
	//headers['X-Quickline-App'] = xAppHeader
	/*
   if (!alerted) alert(xAppHeader)
   alerted = true
	*/
   /*
	console.debug("appVersion %o, uaParsed %o", {
      version: appVersion(),
      browser: `${browserName()} ${browserVersion()}`,
      os: browserOs(),
      isMobile: isMobileScreenSize(),
      isPhoneSize: isPhoneSize(),
      isIpad: isIpad() && !isMobileScreenSize(),
      isAndroid: isAndroid(),
      isDesktop: isDesktop(),
      xAppHeader: xAppHeader,
      userAgent: navigator.userAgent,
		userAgentData: navigator.userAgentData
   }, parsed)
	*/
   return headers
})
